import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'heightMaskPipe' })
export class HeightMaskPipe implements PipeTransform {
  transform(height: string): string {
    if (height) {
      let feet = parseInt(height) / 12;
      let inch = parseInt(height) % 12;
      return Math.floor(feet).toString() + " ' " + inch.toString() + '"';
    } else {
      return height;
    }
  }
}
